import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  NumberField,

  ChipField,
  FunctionField,
} from 'react-admin';

const challengeTypeChoices = [
  { id: 'QUIT_SMOKING', name: 'Бросить курить' },
  { id: 'QUIT_PORN', name: 'Бросить порно' },
  { id: 'QUIT_SUGAR', name: 'Бросить сахар' },
  { id: 'QUIT_ALCOHOL', name: 'Бросить алкоголь' },
  { id: 'EXERCISE', name: 'Упражнения' },
  { id: 'MEDITATION', name: 'Медитация' },
  { id: 'READING', name: 'Чтение' },
  { id: 'WATER_DRINKING', name: 'Пить воду' },
  { id: 'SLEEP_SCHEDULE', name: 'Режим сна' },
  { id: 'NO_SOCIAL_MEDIA', name: 'Без соцсетей' },
  { id: 'CUSTOM', name: 'Кастомный' },
];

const challengeStatusChoices = [
  { id: 'ACTIVE', name: 'Активный' },
  { id: 'PAUSED', name: 'Приостановлен' },
  { id: 'COMPLETED', name: 'Завершен' },
  { id: 'FAILED', name: 'Провален' },
];

const challengeModeChoices = [
  { id: 'PERSONAL', name: 'Личный' },
  { id: 'GROUP', name: 'Групповой' },
];

const ChallengeFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="type"
      choices={challengeTypeChoices}
      label="Тип"
    />
    <SelectInput
      source="status"
      choices={challengeStatusChoices}
      label="Статус"
    />
    <SelectInput
      source="mode"
      choices={challengeModeChoices}
      label="Режим"
    />
    <SelectInput
      source="isStaked"
      choices={[
        { id: true, name: 'Со стейкингом' },
        { id: false, name: 'Без стейкинга' },
      ]}
      label="Стейкинг"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const TypeChip = ({ record }: any) => {
  if (!record || !record.type) return <span>-</span>;
  const typeChoice = challengeTypeChoices.find(choice => choice.id === record.type);
  return <ChipField record={{ value: typeChoice?.name || record.type }} source="value" />;
};

const StatusChip = ({ record }: any) => {
  if (!record || !record.status) return <span>-</span>;
  const statusChoice = challengeStatusChoices.find(choice => choice.id === record.status);
  const getColor = (status: string) => {
    switch (status) {
      case 'ACTIVE': return 'success';
      case 'COMPLETED': return 'primary';
      case 'PAUSED': return 'warning';
      case 'FAILED': return 'error';
      default: return 'default';
    }
  };
  
  return (
    <ChipField 
      record={{ value: statusChoice?.name || record.status }} 
      source="value" 
      color={getColor(record.status)}
    />
  );
};

export const ChallengeList = () => (
  <List
    filters={<ChallengeFilter />}
    actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid>
      <TextField source="id" label="ID" />
      <TextField source="title" label="Название" />
      <FunctionField 
        label="Тип"
        render={(record: any) => <TypeChip record={record} />}
      />
      <FunctionField 
        label="Статус"
        render={(record: any) => <StatusChip record={record} />}
      />
      
      {/* Автор */}
      <TextField source="user.name" label="Автор" />
      
      {/* Статистика */}
      <NumberField source="currentStreak" label="Текущая серия" />
      <NumberField source="bestStreak" label="Лучшая серия" />
      <NumberField source="totalDays" label="Всего дней" />
      <NumberField source="participantsCount" label="Участники" />
      <NumberField source="successRate" label="% успеха" />
      
      {/* Настройки */}
      <BooleanField source="isPublic" label="Публичный" />
      <BooleanField source="isStaked" label="Стейкинг" />
      <TextField source="stakedAmount" label="Сумма стейка" />
      
      {/* Даты */}
      <DateField source="startDate" label="Дата начала" />
      <DateField source="endDate" label="Дата окончания" />
      <DateField source="createdAt" label="Создан" />
      
      <EditButton />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
